(() => {
  if (window.__glxBundleExclusiveV10E3Loaded) return;
  window.__glxBundleExclusiveV10E3Loaded = true;

  const CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout-button]';

  function api() {
    return window.GlowinexBYLMarkerlessV3 || window.GlowinexBYLMarkerlessV2 || null;
  }

  document.addEventListener('click', async (event) => {
    const checkout = event.target?.closest?.(CHECKOUT_SELECTOR);
    if (!checkout || checkout.hasAttribute('data-glx-byl-checkout-ready')) return;

    const controller = api();
    if (!controller?.sync) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    let bundleDetected = controller.bundleGuardActive?.() === true;

    try {
      const state = await controller.sync({ strict: true });
      bundleDetected = bundleDetected || state?.bundleMarkerPresent === true;
      if (state?.bundleMarkerPresent && !state.eligible) {
        throw new Error('Build Your Light cart validation failed.');
      }
    } catch (error) {
      console.warn('[Glowinex BYL] Checkout sync failed.', error);
      if (bundleDetected) {
        window.alert('We could not verify your Build Your Light bundle discount. Please refresh the cart and try again before checkout.');
        return;
      }
    }

    checkout.setAttribute('data-glx-byl-checkout-ready', 'true');
    checkout.click();
  }, true);
})();